import React, { useEffect } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import Routes from './Routes';
import { useLanguage } from './Hooks';
import { Segment } from './Helpers/Segment.helper';
import { SegmentPageName } from './Constants/Segment.constants';

const getPageName = () => {
  const foundMatch = Object.keys(SegmentPageName).find((key) => {
    const currentPath = useRouteMatch(key);
    const isExact = currentPath?.isExact;
    return isExact;
  });
  return foundMatch ? SegmentPageName?.[foundMatch] : null;
};

const useRootContainer = () => {
  const { onLanguageChange, currentLanguage } = useLanguage();
  const foundMatch = getPageName();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const lang = searchParams.get('lang');
    if (lang && lang !== currentLanguage) {
      searchParams.delete('lang');
      history.replace({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
      onLanguageChange(lang);
    }
  }, [location?.search]);

  useEffect(() => {
    Segment.pageview('generic_page_view', location.pathname); // fire a generic page view on all pages
    if (foundMatch) {
      Segment.pageview(foundMatch, location.pathname);
    }
  }, [foundMatch, location.pathname]);
};

const RootContainer = () => {
  useRootContainer();
  return <Routes />;
};

export default RootContainer;
